import { render } from "./ShareComponent.vue?vue&type=template&id=4075c17f"
import script from "./ShareComponent.vue?vue&type=script&lang=js"
export * from "./ShareComponent.vue?vue&type=script&lang=js"

import "./ShareComponent.vue?vue&type=style&index=0&id=4075c17f&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__